import React from 'react'
import { connect } from 'react-redux'
import Loader from 'components/D3Loader'
import { modalActions } from 'store/modal'
import { drawerActions } from 'store/drawer'
import { getBaseSiteIdFromStudy, getUserRoleByStudy, getUserScope } from 'utils/misc'
import { USER_ROLES_MAP } from 'utils/constants'
import SadCloud from 'components/SadCloud'
import InstrumentsView from '../components/InstrumentsView'
import InstrumentWizard from '../components/InstrumentWizard'
import hiddenTasks from '../../../utils/instrumentConstants'
import { actions as instrumentsActions } from '../modules/Instruments'
import { surveyActions } from '../../Instrument/routes/EditSurvey/modules/Survey'
import { clinroActions } from '../../Instrument/routes/EditClinro/modules/Clinro'
import { diaryActions } from '../../Instrument/routes/EditDiary/modules/Diary'
import { instrumentActions, resetInstrument, schedulerActions } from '../../Instrument/modules/Instrument'
import { actions as uploadActions } from '../../Instrument/routes/UploadSurvey/modules/UploadSurvey'
import { downloadData, downloadBulkData } from '../../../../Participants/routes/ParticipantsPage/modules/Participants'
import { fetchVisitTemplates } from '../../../../Participants/routes/CreateParticipant/modules/CreateParticipant'
import { actions as siteActions } from '../../../../Sites/routes/SitesPage/modules/Sites'
import { isVersionUatOrLive } from '../../../../../../../../../utils/studyConfigUtils'

const mapStateToProps = (
  {
    instruments,
    loading,
    location,
    participants,
    searchTerm,
    study,
    studyLock,
    upload,
    user,
    instrumentReducer,
    visitSchedules,
    sites,
  },
  ownProps,
) => {
  const { studyVersionID } = ownProps?.params || {}
  const { currentStudy, studyVersionList } = study
  const studyVersion = studyVersionList?.find(item => item?.version_id === studyVersionID)
  const currentVersionStatus = studyVersion?.version_status || ''
  const { config } = currentStudy
  const paramStudyID = ownProps?.params?.studyID
  const studyID = paramStudyID != null ? Number(paramStudyID) : currentStudy?.id
  const { allInstruments, instrumentList, visitNames, wizardTitle, wizardDisplayName } = instruments
  const { instrumentAdvancedOptions } = instrumentReducer
  const list = instrumentList
  const userRole = getUserRoleByStudy(user, studyID)
  const canSeeGeofencedInstruments = [USER_ROLES_MAP.root, USER_ROLES_MAP.dchAdmin].includes(userRole)
  let filteredList = list
  const { cohortMap } = participants

  const hasClinro = !!config?.clinro
  const hasDiary = !!config?.ediary
  const hasMedAdherence = !!config?.medication_adherence
  const hasAudio = true

  const hasStudyPromotion = !!study?.currentStudy?.config?.study_promotion
  const isReadOnlyState = hasStudyPromotion && isVersionUatOrLive(studyVersionList, studyVersionID)

  if (!canSeeGeofencedInstruments && list.length > 0) {
    filteredList = list.filter(item => !item[0].isGeofenceEnabled && !hiddenTasks.includes(item[0].taskName))
  }

  const isVisitCycleSupported = currentStudy?.config?.visit_support?.version > 1

  const arms = visitSchedules?.studyVisitSchedule || []

  const getVisitsList = () => {
    if (!arms || !isVisitCycleSupported) {
      return []
    }

    const phases = arms?.reduce((acc, schedule) => {
      return [...acc, ...(schedule?.phases || [])]
    }, [])

    const cycles = phases?.reduce((acc, phase) => {
      return [...acc, ...(phase?.cycles || [])]
    }, [])

    const visits = cycles?.reduce((acc, cycle) => {
      return [...acc, ...(cycle?.visits || [])]
    }, [])

    return visits
  }

  const allVisitsList = getVisitsList()

  const { leafSites, siteSelectionList } = sites
  // Prefer URL studyID so scope works while currentStudy is still hydrating after login.
  const userScope = getUserScope(user, studyID)

  return {
    allInstruments,
    ...upload,
    canWrite: userScope.includes('wa'),
    canViewVisits: userScope.includes('rpv'),
    hasVisitSupport: !!currentStudy?.config?.visit_support,
    cohortMap,
    componentLoading: loading,
    currentVersionStatus,
    hasClinro,
    hasStudyPromotion,
    hasDiary,
    hasMedAdherence,
    hasAudio,
    leafSites,
    list: filteredList,
    loading: loading.general,
    modules: study.currentStudy.modules,
    searchTerm,
    showWizard: filteredList.length === 0 && !loading.general,
    siteID: getBaseSiteIdFromStudy(study),
    studyID,
    userId: user.id,
    userToken: user.token || user.access_token,
    studyLock,
    currentStudy,
    visitNames,
    instrumentAdvancedOptions,
    wizardTitle,
    wizardDisplayName,
    study: currentStudy,
    siteSelectionList,
    allVisitsList,
    isReadOnlyState,
    studyVersionID,
  }
}

const { initializeBlankSurvey } = surveyActions
const { initializeBlankClinro } = clinroActions
const { initializeBlankDiary } = diaryActions

const { resetAdvancedOptions } = schedulerActions

const mapDispatchToProps = {
  ...instrumentsActions,
  ...uploadActions,
  ...instrumentActions,
  ...modalActions,
  ...drawerActions,
  downloadData,
  downloadBulkData,
  initializeBlankSurvey,
  initializeBlankClinro,
  initializeBlankDiary,
  resetInstrument: type => resetInstrument(type),
  fetchVisitTemplates,
  resetAdvancedOptions,
  ...siteActions,
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(props => {
  const { canWrite, loading, list, showWizard } = props
  if (loading) {
    return <Loader />
  }
  if (!canWrite && list.length === 0) {
    return <SadCloud text='There are 0 instruments. Please check back later.' />
  }
  return showWizard ? <InstrumentWizard {...props} /> : <InstrumentsView {...props} />
})
